import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2odghsszwq: FaireBrandEntity = {
  token: "b_2odghsszwq",
  type: "brand",
  name: "Goodnightdoll",
  avatarUrl:
    "https://cdn.faire.com/fastly/41253d930ffc1e572ced85dd8c69da124b0caf375dc9b9703de6c75205bb7597.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6b5cfe3367945af3d554d96f22cb2c1d7157f48800e9182cd6e5e642a74fd530.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/41253d930ffc1e572ced85dd8c69da124b0caf375dc9b9703de6c75205bb7597.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6b5cfe3367945af3d554d96f22cb2c1d7157f48800e9182cd6e5e642a74fd530.jpeg",
  location: "Cedar city , UT, USA",
  minimumOrderDollars: 75,
  rating: 3.1,
  reviewCount: 10,
  isInsider: true,
  description:
    "Hi I’m Shawna the founder and creator of Goodnightdoll.  My company started out from my kitchen table hand making crib sheets for my daughter that arrived in 2015.  From there I expanded and started adding in some favorites like knotted gowns, footies and swaddles.  Goodnightdoll is a small woman owned business that specializes in handmade.  Behind every small business is a family.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:08.606Z",
    importedBy: "entity-db-cli",
  },
};
